import React, { Component } from "react";
import Transactions from '../components/Transactions';

class TransactionSummary extends Component {

  constructor(props) {
    super(props);

    this.state = {
        
    }

  }


  render() {
    return(
        <div className='transactionSummary'>
            <Transactions user={this.props.user} compSettings={this.props.compSettings} portfolio={this.props.portfolio} household={this.props.household} idToken={this.props.idToken}/>
        </div>
    );
  }

}

export default TransactionSummary;